/**
 * Implement Gatsby's Browser APIs in this file.
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import React from 'react'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'

const cache = createCache({ key: 'css' })

// Wrap the root element to support React 18 features
export const wrapRootElement = ({ element }) => {
  return (
    <CacheProvider value={cache}>
      {element}
    </CacheProvider>
  )
}